import { render, staticRenderFns } from "./IntentsUsagesTable.vue?vue&type=template&id=44922453&"
import script from "./IntentsUsagesTable.vue?vue&type=script&lang=js&"
export * from "./IntentsUsagesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports